import { observer } from "mobx-react-lite";
import { store } from "../../../../../stores/Store";
import { Button } from "@mui/material";
import { Alert, AlertModal } from "../../../../..";
import EnquiryResumeForm from "../../../../form/enquiry/EnquiryResumeForm";
import EnquiryOutcomeDetails from "./EnquiryOutcomeDetails";
import { UTCDate } from "@date-fns/utc";


function Wrapper ({children}) {
    return (
        <div className="detail-section">
            <div className="section-header">
                <div className="header-content" style={{justifyContent: "left", gap: "7px"}}>
                    <h4>Next steps</h4>
                </div>

                <div className="section-subheader" style={{border: "none", flexDirection: "column", alignItems: "unset"}}>
                    {children}
                </div>
            </div>
        </div>
    )
}


export default observer(function EnquiryCta () {

    const { readOnly, sessionState, sessionInfo } = store.AppStore
    const { enquiry } = store.EnquiryStore

    if (!enquiry) return <></>

    const statusesSection = enquiry.childrenObjects?.find(c => c.name === "STATUSES")
    const positiveStatus = statusesSection?.childrenObjects?.find(s => s.selected && s.value === "Y")
    const outcomeStatement = positiveStatus ? "The enquiry has reached a positive outcome." : "The outcome of the enquiry was negative."
    const validReports = !!store.ReportStore.enquiryReports?.find(r => r.valid)
    const enquiryRanPriorToLastUpdate = new UTCDate(enquiry.lastDefinitiveOutcomeDt) < new UTCDate(sessionInfo.versionDate)

    if (enquiry.status === "INTERIM") {
        return (
            <Wrapper>
                <small>This enquiry has reached an outcome based on the information you provided and also some assumptions made by AORA. For a full outcome you must confirm these assumptions.</small>
                
                <Button
                    color="success"
                    className="btn btn-md"
                    variant="contained"
                    disabled={!!sessionState || readOnly}
                    style={{margin: "8px 0"}}
                    onClick={() => AlertModal({body: <EnquiryResumeForm />, title: "Confirm assumptions", width: "700px"})}>
                    Confirm assumptions
                </Button>
            </Wrapper>
        )
    }

    if (enquiry.status === "REPORT_DATA_REQUIRED" || enquiry.status === "FINAL") {
        return (
            <Wrapper>
                <small>This enquiry has reached a full outcome, however, the reports which you requested require some more information.</small>
                
                <Button
                    color="success"
                    className="btn btn-md"
                    variant="contained"
                    disabled={!!sessionState || readOnly}
                    style={{margin: "8px 0"}}
                    onClick={() => AlertModal({body: <EnquiryResumeForm />, title: "Complete now", width: "700px"})}>
                    Complete now
                </Button>
            </Wrapper>
        )
    }

    if (enquiry.status === "RERUN_REQUIRED") {
        return (
            <Wrapper>
                <small>This enquiry has reached an outcome, however, the data has since been changed and the enquiry must be rerun.</small>

                <Button
                    color="success"
                    className="btn btn-md"
                    variant="contained"
                    disabled={!!sessionState || readOnly}
                    style={{margin: "8px 0"}}
                    onClick={() => AlertModal({body: <EnquiryResumeForm />, title: "Rerun enquiry", width: "700px"})}>
                    Rerun enquiry
                </Button>
            </Wrapper>
        )
    }

    if (enquiry.status === "INITIAL") {
        return (
            <Wrapper>
                <small>This enquiry has not yet reached an outcome.</small>

                <Button 
                    color="success"
                    className="btn btn-md"
                    variant="contained"
                    disabled={!!sessionState || readOnly}
                    style={{margin: "8px 0"}}
                    onClick={() => AlertModal({body: <EnquiryResumeForm />, title: "Resume enquiry", width: "700px"})}>
                    Resume enquiry
                </Button>
            </Wrapper>
        )
    }

    if (enquiry.status === "DEFINITIVE" && !validReports) {
        return (
            <Wrapper>
                <small>{outcomeStatement}</small>

                <Button
                    color="success"
                    variant="contained"
                    className="btn btn-md"
                    style={{margin: "8px 0"}}
                    disabled={!!sessionState || readOnly}
                    onClick={async () => {
                        store.AlertStore.Close()
                        var alert = Alert({message: "Generating reports..."})
                        await store.ReportStore.orderAllReports(enquiry.uid).catch(() => {
                            Alert({message: "Failed to get outcome details"})
                            alert.dismiss()
                        })

                        // setTimeout(() => {
                        //     var outcomeDetailsQueue = setInterval(() => {
                        //         console.log("Waiting to open outcome details", store.AppStore.sessionState)
                        //         if (!store.AppStore.sessionState) {
                        //             AlertModal({title: "Outcome details", width: "850px", body: (
                        //                 <EnquiryOutcomeDetails enquiry={enquiry} />
                        //             )})
                        //             clearInterval(outcomeDetailsQueue)
                        //         }
                        //     }, 2000)
                        // }, 3000)
                    }}>
                    View outcome details
                </Button>
            </Wrapper>
        )
    }

    if (enquiry.status === "DEFINITIVE" && enquiryRanPriorToLastUpdate) {
        return (
            <Wrapper>
                <small>{outcomeStatement} The server has been updated since this enquiry was last run.</small>

                <Button
                    color="success"
                    variant="contained"
                    className="btn btn-md"
                    style={{margin: "8px 0"}}
                    disabled={!!sessionState || readOnly}
                    onClick={() => store.EnquiryStore.rerun()}>
                    Rerun Assessment
                </Button>
            </Wrapper>
        )
    }

    return <></>
})